<template>
  <slot
    :balance="$stores.wallet.state[userId]?.balance"
    :error="$stores.wallet.state[userId]?.error"
    :loading="$stores.wallet.state[userId]?.loading"
  >
    <div class="inline-flex gap-1 items-center">
      {{
        $stores.wallet.state[userId]?.loading
          ? 'chargement...'
          : $stores.wallet.state[userId]?.error
          ? 'Erreur !'
          : $stores.wallet.state[userId]?.balance ?? '...'
      }}
      <div v-bus:EVENTS.WALLET.REFRESH.click>
        <ColorImg
          src="/images/all/load.png"
          class="bg-current w-8 h-8"
          :class="{ 'animate-spin': $stores.wallet.state[userId]?.loading }"
          v-if="
            $stores.wallet.state[userId]?.loading ||
            $stores.wallet.state[userId]?.error
          "
          alt=""
        />
      </div>
    </div>
  </slot>
</template>

<script setup>
import { getCurrentInstance, watch } from 'vue';

const props = defineProps({
  userId: String
});

const { proxy } = getCurrentInstance();
const { $stores, $bus, $constants } = proxy;

$bus.emit($constants.EVENTS.WALLET.REFRESH, { userId: props.userId });

watch(
  () => props.userId,
  (newVal) => {
    $bus.emit($constants.EVENTS.WALLET.REFRESH, { userId: newVal });
  }
);
</script>
